'use client';
import { loadStripe } from '@stripe/stripe-js';

// The live site should never fail on a stripe key missing from config:
const PROD_PUBLIC_STRIPE_KEY =
  'pk_live_51PceAtHkXE6ArGGnF98K3oCTElytCzMBOBpe8XRMfVjrAQlbXi5EmYjhekSZ0RYWB5AgsouvXqLJx7FbKInihQyE00ghfsWpNm';

export const stripe = await loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY ?? PROD_PUBLIC_STRIPE_KEY);
